// İSG Portal — auth iş akışları (client + store köprüsü).
//
// KAYNAK: api-contract.md §5.2 / §5.3 / §5.8. Tüm uçlar anonim (`auth: false` —
// access token ekleme, 401'de refresh deneme). Başarılı login oturumu store'a yazar.

import { api } from '../api/client';
import type { Empty } from '../api/envelope';
import { useAuthStore } from './store';
import type {
  ForgotPasswordRequest,
  LoginRequest,
  ResetPasswordRequest,
  TokenPairDto,
} from './types';

/** User login — api-contract §5.2. Başarıda oturum store'a yazılır. */
export async function login(request: LoginRequest): Promise<TokenPairDto> {
  const tokens = await api.post<TokenPairDto>('auth/login', {
    json: { email: request.email, password: request.password },
    auth: false,
  });
  useAuthStore.getState().setSession({
    accessToken: tokens.accessToken,
    refreshToken: tokens.refreshToken,
  });
  return tokens;
}

/** Oturumu kapatır (local temizlik; foundation'da sunucu-taraflı logout ucu yok). */
export function logout(): void {
  useAuthStore.getState().clear();
}

/** Parola sıfırlama 1. adım — api-contract §5.8.1 (enumeration-safe: her zaman 200). */
export async function forgotPassword(request: ForgotPasswordRequest): Promise<Empty> {
  return api.post<Empty>('auth/forgot-password', {
    json: { emailOrPhone: request.emailOrPhone },
    auth: false,
  });
}

/** Parola sıfırlama 2. adım — api-contract §5.8.2 (OTP + yeni parola). */
export async function resetPassword(request: ResetPasswordRequest): Promise<Empty> {
  return api.post<Empty>('auth/reset-password', {
    json: {
      emailOrPhone: request.emailOrPhone,
      code: request.code,
      newPassword: request.newPassword,
    },
    auth: false,
  });
}
